import { Button, Icon } from '@platform/components';
import { ReactNode } from 'react';

type CommunityPaginationBarProps = {
  numPages: number;
  currentPage: number;

  onPageSelect: (page: number) => void;
};

export const CommunityPaginationBar = (props: CommunityPaginationBarProps) => {
  const { numPages, currentPage, onPageSelect } = { ...props };

  const buttonsToRender = [];

  for (let i = 1; i <= numPages; i++) {
    if (i <= 3) {
      buttonsToRender.push(
        <PaginationPip onPageSelect={() => onPageSelect(i)} content={i} bold={i === currentPage} />
      );
      if (numPages > 6) {
        buttonsToRender.push(<PaginationPip content={'...'} bold={i === currentPage} />);
      }
    } else if (i <= numPages - 3) {
      buttonsToRender.push(
        <PaginationPip onPageSelect={() => onPageSelect(i)} content={i} bold={i === currentPage} />
      );
    }
  }

  const isNextEnabled = currentPage < numPages;
  const isPreviousEnabled = currentPage > 1;

  const onClickNext = () => {
    if (isNextEnabled) {
      onPageSelect(currentPage + 1);
    }
  };

  const onClickPrevious = () => {
    if (isPreviousEnabled) {
      onPageSelect(currentPage - 1);
    }
  };

  return (
    <div className='flex flex-row justify-between w-full pt-5 mt-10 border-t border-border-secondary items-center h-[60px]'>
      <Button
        variant='tertiary-gray'
        size='md'
        onPress={onClickPrevious}
        isDisabled={!isPreviousEnabled}
      >
        <Icon type='arrow-left' size='16' />
        Previous
      </Button>
      <div className='flex flex-row gap-1'>{buttonsToRender}</div>
      <Button variant='tertiary-gray' size='md' onPress={onClickNext} isDisabled={!isNextEnabled}>
        Next
        <Icon type='arrow-right' size='16' />
      </Button>
    </div>
  );
};

type PaginationPipProps = {
  content: ReactNode;
  bold?: boolean;
  onPageSelect?: () => void;
};
export const PaginationPip = (props: PaginationPipProps) => {
  const { content, bold, onPageSelect } = { ...props };
  return (
    <div
      onClick={onPageSelect}
      className={`text-sm w-4 h-4 ${bold ? 'font-semibold' : ''} ${
        onPageSelect ? 'cursor-pointer' : ''
      }`}
    >
      {content}
    </div>
  );
};
